var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ContainerGrid",attrs:{"pl-0":"","pr-0":"","py-0":_vm.noPadding,"grid-list-md":"","fluid":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }